export default __webpack_public_path__ + "static/16-3aeca11fb25c3a1adf0303f0c94bd84a.svg";